import React from 'react';
import Box from '@mui/material/Box';
import {
  IRapportContainerControl,
  IRapportMallControl,
} from './RapportMallTypes';
import {
  HOVER_SHADOW,
  SELECTED_SHADOW,
  getPositionStyle,
  getZIndexesForControls,
} from './RapportMallUtils';
import { RapportKontroll } from './RapportKontroll';
import { RapportKontrollEditPosition } from './RapportKontrollEditPosition';
import { RapportFontProvider } from './RapportFontContext';
import { RapportKontrollHeader } from './RapportKontrollHeader';
import TextField from '@mui/material/TextField';

export interface IProps {
  ctrl: IRapportContainerControl;
  sx?: any;
  onSelect?: (path: number[]) => void;
  onUpdate?: (
    controlPath: number[],
    updatedControl: IRapportMallControl
  ) => void;
  controlPath: number[];
  selectedPath?: number[];
  selected?: boolean;
  maxWidth: number;
  defaultHeight: number;
  zIndex?: number; // Används för att hantera z-index i behållare
  showDottedBorders: boolean;
}

export const RapportContainer: React.FC<IProps> = props => {
  const {
    ctrl,
    onSelect,
    onUpdate,
    controlPath,
    selectedPath,
    selected,
    sx,
    maxWidth,
    defaultHeight,
  } = props;
  const [childHovering, setChildHovering] = React.useState(false);
  const [containerHovering, setContainerHovering] = React.useState(false);
  const content = ctrl.Content || [];
  const zIndexes = getZIndexesForControls(content, 1);

  const handleSelect = () => {
    if (onSelect) {
      onSelect(controlPath);
    }
  };
  const ctrlWidth = ctrl.Width ?? maxWidth;
  const ctrlHeight = ctrl.Height ?? defaultHeight;
  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        position: 'relative',
        ...getPositionStyle(
          ctrl,
          props.controlPath.length > 1,
          ctrlWidth,
          ctrlHeight
        ),
        transition: 'box-shadow 0.2s, border-color 0.2s',
        boxShadow: selected
          ? SELECTED_SHADOW
          : containerHovering && !childHovering
          ? HOVER_SHADOW
          : undefined,
        zIndex: props.zIndex,
        ...sx,
      }}
      onMouseEnter={() => setContainerHovering(true)}
      onMouseLeave={() => setContainerHovering(false)}
      onClick={e => {
        e.stopPropagation();
        handleSelect();
      }}
      data-control-path={props.controlPath.join('-')}
    >
      <RapportFontProvider defaultFont={ctrl.DefaultFont}>
        {content.map((child: IRapportMallControl, i: number) => (
          <RapportKontroll
            ctrl={child}
            idx={i}
            key={i}
            maxWidth={ctrlWidth}
            defaultHeight={ctrlHeight}
            setChildHovering={setChildHovering}
            onSelect={onSelect}
            onUpdate={onUpdate}
            controlPath={[...controlPath, i]}
            selectedPath={selectedPath}
            zIndex={zIndexes[i]}
            showDottedBorders={props.showDottedBorders}
          />
        ))}
      </RapportFontProvider>
    </Box>
  );
};

export interface IRapportContainerEditProps {
  value: IRapportContainerControl;
  onChange: (ctrl: IRapportContainerControl) => void;
}

export const RapportContainerEdit: React.FC<
  IRapportContainerEditProps
> = props => (
  <Box sx={{ mt: 2 }}>
    <RapportKontrollHeader value={props.value} />
    <TextField
      label="Font"
      value={props.value.DefaultFont}
      onChange={e =>
        props.onChange({ ...props.value, DefaultFont: e.target.value })
      }
      fullWidth
      size="small"
      sx={{ mb: 2 }}
    />
    <RapportKontrollEditPosition
      value={props.value}
      onChange={props.onChange}
    />
  </Box>
);
